import { render } from "./ViewProcess.vue?vue&type=template&id=39036d11&scoped=true"
import script from "./ViewProcess.vue?vue&type=script&lang=js"
export * from "./ViewProcess.vue?vue&type=script&lang=js"

import "./ViewProcess.vue?vue&type=style&index=0&id=39036d11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39036d11"]])

export default __exports__